import React from 'react';

const programs = [
  {
    title: 'ETA Tots',
    age: '18 months–2 years',
    points: [
      '30 min paid session + 15 min free play (parent must be present for full 45 minutes)',
      'Montessori-based, play-based, and music-based learning',
      'Exposure to letters, numbers, tracing, real-world concepts and 1-step instruction',
      'Program develops classroom etiquette, communication, and fine-motor skills',
      'Fosters independence, curiosity, confidence, and a love of learning',
    ],
  },
  {
    title: 'ETA Tinies',
    age: '2–7 years',
    points: [
      'Montessori-based, play-based learning with worksheets',
      'Builds foundations in literacy, numeracy, writing, problem-solving & real-world skills',
      'Introduction to abstract, complex concepts up to 2 grade levels ahead',
      'Program develops independence, curiosity, confidence, and critical thinking',
      'Expectations foster self-regulation, responsibility, and resilience',
    ],
  },
  {
    title: 'ETA Tykes',
    age: '7–11 years',
    points: [
      'Montessori-based learning with worksheets',
      'Supports students in mastering abstract concepts in literacy, writing, and arithmetic',
      'Builds critical thinking, problem-solving skills, and real-world connections',
      'Expectations heightened to foster initiative, curiosity, leadership, test-taking skills, time management, and effective study habits',
    ],
  },
  {
    title: 'ETA Tweens & Teens',
    age: '11+ years',
    points: [
      'Worksheet-focused academic program supported by Montessori philosophies',
      'Supports academic advancement and filling foundational learning gaps',
      'Introduces middle and high school-level concepts',
      'Builds real-world skills, including financial planning and professional communication',
      'Fosters leadership, discipline, initiative, proactive study habits, curiosity, critical thinking, and test-taking skills',
    ],
  },
];

const Programs: React.FC = () => {
  return (
    <section className="bg-white px-4 py-12 md:py-20">
      <div className="max-w-6xl mx-auto">
        <div className="space-y-6 md:space-y-12">
          {programs.map((prog, i) => (
            <div key={i} className="rounded-2xl border border-gray-100 bg-gray-50 p-4 sm:p-6 md:p-8">
              <h3 className="text-xl font-bold text-black sm:text-2xl">
                {prog.title} <span className="text-mainBlue font-medium">| {prog.age}</span>
              </h3>
              <ul className="mt-4 space-y-2">
                {prog.points.map((point, j) => (
                  <li key={j} className="flex items-start gap-3 text-base md:text-lg text-gray-700">
                    <span className="text-mainBlue mt-1 flex-shrink-0">•</span>
                    <span>{point}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Programs;